import { loadOptions } from '../formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '0', label: 'CIF' },
			{ value: '1', label: 'FOB' },
			{ value: '2', label: 'Terceiros' },
			{ value: '3', label: 'Próprio/Remetente' },
			{ value: '4', label: 'Próprio/Destinatário' },
			{ value: '9', label: 'Sem Transporte' }
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

